import { render, staticRenderFns } from "./CompaniesStatsHeader.vue?vue&type=template&id=5e44c4fe&"
import script from "./CompaniesStatsHeader.vue?vue&type=script&lang=ts&"
export * from "./CompaniesStatsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CompaniesStatsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports